/**
 * SafetyCheck
 * The SafetyCheck API
 *
 * The version of the OpenAPI document: master-35d84d79-917289
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { ConfigAuditDto } from '../model/configAuditDto';
import { ConfigCreateDto } from '../model/configCreateDto';
import { ConfigDto } from '../model/configDto';
import { ConfigUpdateDto } from '../model/configUpdateDto';
import { EffectiveConfigDto } from '../model/effectiveConfigDto';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class ConfigApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     * @param id 
     */
    public deleteConfig(id: string, ): Observable<AxiosResponse<any>>;
    public deleteConfig(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<any>(`${this.basePath}/config/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public deleteOrganizationConfig(id: string, ): Observable<AxiosResponse<any>>;
    public deleteOrganizationConfig(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrganizationConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<any>(`${this.basePath}/config/organization/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public deleteOrganizationGroupConfig(id: string, ): Observable<AxiosResponse<any>>;
    public deleteOrganizationGroupConfig(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrganizationGroupConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<any>(`${this.basePath}/config/organization-group/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getConfig(id: string, ): Observable<AxiosResponse<ConfigDto>>;
    public getConfig(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<ConfigDto>(`${this.basePath}/config/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getConfigHistoryForOrganization(id: string, ): Observable<AxiosResponse<Array<ConfigAuditDto>>>;
    public getConfigHistoryForOrganization(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getConfigHistoryForOrganization.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Array<ConfigAuditDto>>(`${this.basePath}/config/organization/${encodeURIComponent(String(id))}/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getConfigHistoryForOrganizationGroup(id: string, ): Observable<AxiosResponse<Array<ConfigAuditDto>>>;
    public getConfigHistoryForOrganizationGroup(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getConfigHistoryForOrganizationGroup.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Array<ConfigAuditDto>>(`${this.basePath}/config/organization-group/${encodeURIComponent(String(id))}/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getEffectiveConfigForOrganization(id: string, ): Observable<AxiosResponse<EffectiveConfigDto>>;
    public getEffectiveConfigForOrganization(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEffectiveConfigForOrganization.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<EffectiveConfigDto>(`${this.basePath}/config/organization/${encodeURIComponent(String(id))}/effective`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getOrganizationConfig(id: string, ): Observable<AxiosResponse<ConfigDto>>;
    public getOrganizationConfig(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrganizationConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<ConfigDto>(`${this.basePath}/config/organization/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getOrganizationGroupConfig(id: string, ): Observable<AxiosResponse<ConfigDto>>;
    public getOrganizationGroupConfig(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrganizationGroupConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<ConfigDto>(`${this.basePath}/config/organization-group/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param configCreateDto 
     */
    public insertConfig(configCreateDto: ConfigCreateDto, ): Observable<AxiosResponse<ConfigDto>>;
    public insertConfig(configCreateDto: ConfigCreateDto, ): Observable<any> {

        if (configCreateDto === null || configCreateDto === undefined) {
            throw new Error('Required parameter configCreateDto was null or undefined when calling insertConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.post<ConfigDto>(`${this.basePath}/config`,
            configCreateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param configUpdateDto 
     */
    public insertOrganizationConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<AxiosResponse<ConfigDto>>;
    public insertOrganizationConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling insertOrganizationConfig.');
        }

        if (configUpdateDto === null || configUpdateDto === undefined) {
            throw new Error('Required parameter configUpdateDto was null or undefined when calling insertOrganizationConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.put<ConfigDto>(`${this.basePath}/config/organization/${encodeURIComponent(String(id))}`,
            configUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param configUpdateDto 
     */
    public insertOrganizationGroupConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<AxiosResponse<ConfigDto>>;
    public insertOrganizationGroupConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling insertOrganizationGroupConfig.');
        }

        if (configUpdateDto === null || configUpdateDto === undefined) {
            throw new Error('Required parameter configUpdateDto was null or undefined when calling insertOrganizationGroupConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.put<ConfigDto>(`${this.basePath}/config/organization-group/${encodeURIComponent(String(id))}`,
            configUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     */
    public listConfig(): Observable<AxiosResponse<Array<ConfigDto>>>;
    public listConfig(): Observable<any> {

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Array<ConfigDto>>(`${this.basePath}/config`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param configUpdateDto 
     */
    public updateConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<AxiosResponse<ConfigDto>>;
    public updateConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateConfig.');
        }

        if (configUpdateDto === null || configUpdateDto === undefined) {
            throw new Error('Required parameter configUpdateDto was null or undefined when calling updateConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.patch<ConfigDto>(`${this.basePath}/config/${encodeURIComponent(String(id))}`,
            configUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param configUpdateDto 
     */
    public updateOrganizationConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<AxiosResponse<ConfigDto>>;
    public updateOrganizationConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateOrganizationConfig.');
        }

        if (configUpdateDto === null || configUpdateDto === undefined) {
            throw new Error('Required parameter configUpdateDto was null or undefined when calling updateOrganizationConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.patch<ConfigDto>(`${this.basePath}/config/organization/${encodeURIComponent(String(id))}`,
            configUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param configUpdateDto 
     */
    public updateOrganizationGroupConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<AxiosResponse<ConfigDto>>;
    public updateOrganizationGroupConfig(id: string, configUpdateDto: ConfigUpdateDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateOrganizationGroupConfig.');
        }

        if (configUpdateDto === null || configUpdateDto === undefined) {
            throw new Error('Required parameter configUpdateDto was null or undefined when calling updateOrganizationGroupConfig.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.patch<ConfigDto>(`${this.basePath}/config/organization-group/${encodeURIComponent(String(id))}`,
            configUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
